import { useEffect, useState } from "react";
import apiClient from "../../../apiClient";
import { Department, ItemType, AttributeDefinition } from "./types";

export default function useCatalog() {
    const [departments, setDepartments] = useState<Department[]>([]);
    const [itemTypes, setItemTypes] = useState<ItemType[]>([]);
    const [definitions, setDefinitions] = useState<AttributeDefinition[]>([]);

    const getCatalog = async () => {
        const [departmentsRes, itemTypesRes, definitionsRes] = await Promise.all([
            apiClient.get(`/inventory-dev/departments?mine=true`),
            apiClient.get(`/inventory-dev/item-types`),
            apiClient.get(`/inventory-dev/attribute-definitions`),
        ]);
        setDepartments(departmentsRes.data);
        setItemTypes(itemTypesRes.data);
        setDefinitions(definitionsRes.data);
    };

    useEffect(() => {
        getCatalog();
    }, []);

    return { departments, itemTypes, definitions, getCatalog };
}
